<template>
  <section class="panel-filtros">
    <!-- En el celular los filtros se pliegan; en pantalla grande van siempre a la vista, en una sola fila. -->
    <header class="panel-filtros__cabecera" @click="abierto = !abierto">
      <v-icon small color="primary" class="mr-2">mdi-filter-variant</v-icon>
      <strong>Filtros</strong>
      <v-chip v-if="cantidadActivos" x-small color="primary" class="ml-2">{{ cantidadActivos }}</v-chip>
      <v-spacer></v-spacer>
      <v-icon>{{ abierto ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
    </header>
    <div v-show="abierto" class="panel-filtros__cuerpo">
      <ValidationObserver ref="observador" tag="div" class="panel-filtros__fila" @keyup.native.enter="filtrar">
        <div class="panel-filtros__campos">
          <slot></slot>
        </div>
        <div class="panel-filtros__botones">
          <v-btn small text color="secondary" class="panel-filtros__limpiar" title="Limpiar los filtros" @click="limpiar">
            <v-icon small>mdi-eraser</v-icon><span class="ml-1">Limpiar</span>
          </v-btn>
          <v-btn small depressed color="primary" class="panel-filtros__filtrar" :loading="cargando" @click="filtrar">
            <v-icon small left>mdi-filter</v-icon>Filtrar
          </v-btn>
        </div>
      </ValidationObserver>
      <ng-filters-chips v-if="cantidadActivos" :form="form" :labels="labels" @change="$emit('filtrar')" class="panel-filtros__chips"></ng-filters-chips>
    </div>
  </section>
</template>

<script>
/**
 * Filtros de un listado en la misma pantalla: los campos van como contenido (slot) y el botón «Filtrar»
 * emite `filtrar`; «Limpiar» vacía el formulario y vuelve a filtrar. En el celular arranca cerrado.
 */
export default {
  name: "PanelFiltros",
  props: {
    form: { type: Object, default: () => ({}) },
    labels: { type: Object, default: () => ({}) },
    cargando: { type: Boolean, default: false },
  },
  data() {
    return { abierto: window.innerWidth >= 960 };
  },
  computed: {
    cantidadActivos() {
      return Object.keys(this.form || {}).filter((k) => {
        const v = this.form[k];
        if (v === null || v === undefined || v === "") return false;
        if (Array.isArray(v)) return v.length > 0;
        if (typeof v === "object") return Object.keys(v).some((x) => v[x] !== null && v[x] !== "" && v[x] !== undefined);
        return true;
      }).length;
    },
  },
  methods: {
    filtrar() {
      this.$emit("filtrar");
    },
    limpiar() {
      for (const k of Object.keys(this.form || {})) {
        this.$set(this.form, k, "");
      }
      this.$emit("limpiar");
      this.$emit("filtrar");
    },
  },
};
</script>

<style scoped>
.panel-filtros {
  margin: 8px 12px 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
}
.panel-filtros__cabecera {
  display: none;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  color: #3c3c3b;
}
.panel-filtros__cuerpo {
  padding: 10px 12px 2px;
}
.panel-filtros__fila {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.panel-filtros__campos {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-auto-flow: dense;
  gap: 0 12px;
}
.panel-filtros__campos >>> .cols-filters,
.panel-filtros__campos >>> .col {
  max-width: 100%;
  padding: 0;
}
/* El rango de fechas son dos campos: ocupa dos columnas para que la etiqueta no se corte. */
.panel-filtros__campos >>> .ng-date-range,
.panel-filtros__campos >>> *:has(> .ng-date-range) {
  grid-column: span 2;
}
.panel-filtros__campos >>> .v-input__slot {
  margin-bottom: 0;
}
.panel-filtros__campos >>> .v-text-field__details,
.panel-filtros__campos >>> .v-messages {
  min-height: 0;
  margin-bottom: 0;
}
.panel-filtros__campos >>> .mb-3 {
  margin-bottom: 8px !important;
}
.panel-filtros__botones {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  white-space: nowrap;
}
.panel-filtros__chips {
  padding-bottom: 8px;
}
@media (min-width: 960px) {
  .panel-filtros__cuerpo {
    display: block !important;
  }
}
@media (max-width: 959px) {
  .panel-filtros {
    margin: 8px 8px 0;
  }
  .panel-filtros__cabecera {
    display: flex;
  }
  .panel-filtros__cuerpo {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
  .panel-filtros__fila {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
  .panel-filtros__campos {
    grid-template-columns: 1fr;
  }
  .panel-filtros__campos >>> .ng-date-range,
  .panel-filtros__campos >>> *:has(> .ng-date-range) {
    grid-column: auto;
  }
  .panel-filtros__botones {
    justify-content: flex-end;
    padding: 0 0 10px;
  }
}
</style>
